import { render, staticRenderFns } from "./SinoForeignCooperation.vue?vue&type=template&id=3eb2cb97&scoped=true"
import script from "./SinoForeignCooperation.vue?vue&type=script&lang=js"
export * from "./SinoForeignCooperation.vue?vue&type=script&lang=js"
import style0 from "./SinoForeignCooperation.vue?vue&type=style&index=0&id=3eb2cb97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb2cb97",
  null
  
)

export default component.exports